"use client";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { googleLogin } from "@/app/actions/actions";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { usePostHogDistinctId } from "@/hooks/usePostHogDistinctId";

export default function MCTA({ user }: { user: any }) {
  const [isEmbeddedBrowser, setIsEmbeddedBrowser] = useState();
  const params = useParams();
  const posthog = usePostHog();
  const posthogId = usePostHogDistinctId();
  const locale = typeof params.locale === "string" ? params.locale : "en";
  useEffect(() => {
    setIsEmbeddedBrowser(
      // @ts-ignore
      /FBAN|FBAV|FBMS|FB_IAB|FB4A|FBAN\/Messenger/.test(
        window.navigator.userAgent
      )
    );
  }, []);
  const t = useTranslations("Index.MCTA");

  return (
    <>
      {user ? (
        <Button asChild className="max-w-48">
          <Link href="/home">{t("loggedIn")}</Link>
        </Button>
      ) : isEmbeddedBrowser ? (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button>{t("loggedOut")}</Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{t("alertTitle")}</AlertDialogTitle>
              <AlertDialogDescription>{t("alertText")}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>{t("alertOk")}</AlertDialogCancel>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      ) : (
        <form action={googleLogin}>
          <input type="hidden" name="locale" value={locale} />
          <input type="hidden" name="posthogId" value={posthogId} />
          <Button type="submit">{t("loggedOut")}</Button>
        </form>
      )}
    </>
  );
}
